export const getOuterHeight = (element) => {
    const { "margin-top": marginTop, "margin-bottom": marginBottom } =
        window.getComputedStyle(element);
    return element.offsetHeight + parseFloat(marginTop) + parseFloat(marginBottom);
};

export const getOuterWidth = (element) => {
    const { "margin-left": marginLeft, "margin-right": marginRight } =
        window.getComputedStyle(element);
    return element.offsetWidth + parseFloat(marginLeft) + parseFloat(marginRight);
};

export const getElementTopLeft = (element) => {
    const elementRect = element.getBoundingClientRect();
    const { body, documentElement } = document;

    const scrollTop = window.pageYOffset || documentElement.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || documentElement.scrollLeft || body.scrollLeft;
    const clientTop = documentElement.clientTop || body.clientTop || 0;
    const clientLeft = documentElement.clientLeft || body.clientLeft || 0;

    const top = elementRect.top + scrollTop - clientTop;
    const left = elementRect.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
};

export const getScrollbarProperty = () => {
    const windowInnerWidth = window.innerWidth;
    const documentWidth = document.documentElement.clientWidth;
    const hasScrollbar = windowInnerWidth > documentWidth;

    return {
        hasScrollbar,
        scrollbarWidth: hasScrollbar ? windowInnerWidth - documentWidth : 0
    };
};
